import React from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";

interface SSHListPageProps extends NSARouterMakerResult, CredentialProps { }

export default class SSHListPage extends React.Component<SSHListPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section lists all the SSH credentials saved in your workspace, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
                }}
                pages={{
                    entity: CredentialEntities.ssh(this.props),
                    list: {
                        ui: {}
                    }
                }}
            >
                <></>
            </CredentialLayout >
        );
    }
}